import React, { useState } from 'react';
import { Link, ScrollRestoration } from 'react-router-dom';
import { Button } from 'react-bootstrap5';

import routes from 'app/routes';
import StepTab from 'components/new_ui/Tabs/StepTab';
import useFinchPreview from 'components/Common/Members/Hooks/useFinchPreview';
import { useContext } from 'components/Managers/Members/Context';
import Settings from './Settings';
import Preview from './Preview';
import Summary from './Summary';

export default function Import() {
  const { state: { finchOptions } } = useContext();

  const { loading, members } = useFinchPreview();
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [showSettings, setShowSettings] = useState(false);
  const [showSummary, setShowSummary] = useState(false);

  return (
    <>
      <StepTab total={3} current={2} />

      <div className="content">
        <section>
          {finchOptions.synchImport ? (
            <>
              <h1 className="mb-3">Synchronize Members</h1>

              <p>
                Newly added members will be highlighted in green for easy identification,
                while terminated members will be marked in red and will be automatically
                removed from the LeggUP system after synchronization.
              </p>
            </>
          ) : (
            <>
              <h1 className="mb-3">You&apos;re Successfully Connected to LeggUP!</h1>

              <p>
                Congratulations, you&apos;ve successfully connected your HRIS system to LeggUP!
              </p>

              <p>
                You can now adjust synchronization settings for this new link in the settings dialog.
                Clicking the Import button will initiate the import of your entire member directory into LeggUP.
              </p>
            </>
          )}
        </section>

        <footer className="d-sm-flex flex-row-reverse">
          <div className="mb-3 mb-sm-0 ms-sm-3">
            <Button
              className="w-100"
              disabled={loading || selectedMembers.length === 0}
              onClick={() => setShowSummary(true)}
            >
              {finchOptions.synchImport ? 'Synch Members' : 'Import'}
            </Button>
          </div>

          <div className="flex-grow-1 d-flex justify-content-between">
            <Button
              className="btn-reverse"
              onClick={() => setShowSettings(true)}
            >
              Settings
            </Button>

            <Link
              to={routes.managers.members.index}
              className="btn btn-outline-primary"
            >
              Cancel
            </Link>
          </div>
        </footer>
      </div>

      <Settings
        show={showSettings}
        successCallback={() => setShowSettings(false)}
        cancelCallback={() => setShowSettings(false)}
      />

      <Preview
        members={members}
        loading={loading}
        selectedMembers={selectedMembers}
        setSelectedMembers={setSelectedMembers}
      />

      <Summary
        show={showSummary}
        members={members.filter((member) => selectedMembers.includes(member.id))}
        cancelCallback={() => setShowSummary(false)}
      />

      <ScrollRestoration />
    </>
  );
}
